export default {
    namespaced: true,

    state: () => ({
        departments: [],
        loading: false,
    }),

    getters: {
        departments(state) {
            return state.departments.map((item, i) => {
                item.sl = i + 1;
                return item;
            });
        },
        loading: state => state.loading,
    },

    mutations: {
        populateDepartments(state, departments) {
            state.departments = departments;
        },
        changeLoadingStatus: (state, status) => state.loading = status,
    },

    actions: {
        async getDepartments(context) {
            context.commit('changeLoadingStatus', true)
            await axios.get('get-departments', {
                headers: {
                    Authorization: this.getters['auth/jwt']
                }
            })
            .then(res => {
                context.commit('populateDepartments', res.data.departments);
            })
            .catch(error => this.dispatch('snackbar/error', error.message))
            context.commit('changeLoadingStatus', false)
        },
        async saveDepartment(context, department) {
            let isSuccess = false;
            let url = 'add-department';

            if(department.id != null) {
                url = 'update-department';
            }

            await axios.post(url, department, {
                headers: {
                    Authorization: this.getters['auth/jwt']
                }
            }) 
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getDepartments');
            })
            .catch( err => {
                isSuccess = false;
                this.dispatch('snackbar/error', err.response.data.message);
            })

            return isSuccess;
        },

        async deleteDepartment(context, id) {
            let isSuccess = false;
            let url = 'delete-department';

            await axios.post(url, { id }, {
                headers: {
                    Authorization: this.getters['auth/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getDepartments');
            })
            .catch(err => {
                isSuccess = false;
                this.dispatch('snackbar/error', err.response.data.message);
            })
            
            return isSuccess;
        }
    }
}